import { AuthPopupFixed, COLOR } from '@setplex/arcane'
import { useUnit } from 'effector-react'
import { epgRegionsFeature } from '~/features/epg/regions'
import { RegionsForm } from './components/RegionsForm'

RegionsPopup.displayName = 'RegionsPopup'
export function RegionsPopup() {
  const isOpenedRegionsPopup = useUnit(epgRegionsFeature.$isRegionsPopupOpened)

  return (
    <AuthPopupFixed
      wrapperId='regions'
      isOpened={isOpenedRegionsPopup}
      overlayFullColor={COLOR.TRANSPARENT}
    >
      <RegionsForm />
    </AuthPopupFixed>
  )
}
